/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { IntMap, SortedArray } from '../../../../mol-data/int';
import { sortArray } from '../../../../mol-data/util';
import { StructureSymmetry } from '../symmetry';
import { Structure } from '../structure';
var StructureSubsetBuilder = /** @class */ (function () {
    function StructureSubsetBuilder(parent, isSorted) {
        this.parent = parent;
        this.isSorted = isSorted;
        this.ids = [];
        this.unitMap = IntMap.Mutable();
        this.parentId = -1;
        this.currentUnit = [];
        this.elementCount = 0;
    }
    StructureSubsetBuilder.prototype.addToUnit = function (parentId, e) {
        var unit = this.unitMap.get(parentId);
        if (!!unit) {
            unit[unit.length] = e;
        }
        else {
            this.unitMap.set(parentId, [e]);
            this.ids[this.ids.length] = parentId;
        }
        this.elementCount++;
    };
    StructureSubsetBuilder.prototype.beginUnit = function (parentId) {
        this.parentId = parentId;
        this.currentUnit = this.currentUnit.length > 0 ? [] : this.currentUnit;
    };
    StructureSubsetBuilder.prototype.addElement = function (e) {
        this.currentUnit[this.currentUnit.length] = e;
        this.elementCount++;
    };
    StructureSubsetBuilder.prototype.addElementRange = function (elements, start, end) {
        for (var i = start; i < end; i++) {
            this.currentUnit[this.currentUnit.length] = elements[i];
            this.elementCount++;
        }
    };
    StructureSubsetBuilder.prototype.commitUnit = function () {
        if (this.currentUnit.length === 0)
            return;
        this.ids[this.ids.length] = this.parentId;
        this.unitMap.set(this.parentId, this.currentUnit);
        this.parentId = -1;
    };
    StructureSubsetBuilder.prototype.setUnit = function (parentId, elements) {
        this.ids[this.ids.length] = parentId;
        this.unitMap.set(parentId, elements);
        this.elementCount += elements.length;
    };
    StructureSubsetBuilder.prototype._getStructure = function (deduplicateElements) {
        if (this.isEmpty)
            return Structure.Empty;
        var newUnits = [];
        sortArray(this.ids);
        var symmGroups = StructureSymmetry.UnitEquivalenceBuilder();
        for (var i = 0, _i = this.ids.length; i < _i; i++) {
            var id = this.ids[i];
            var parent_1 = this.parent.unitMap.get(id);
            var unit = this.unitMap.get(id);
            var sorted = false;
            if (deduplicateElements) {
                if (!this.isSorted)
                    sortArray(unit);
                unit = SortedArray.deduplicate(SortedArray.ofSortedArray(this.currentUnit));
                sorted = true;
            }
            var l = unit.length;
            // if the length is the same, just copy the old unit.
            if (unit.length === parent_1.elements.length) {
                newUnits[newUnits.length] = parent_1;
                symmGroups.add(parent_1.id, parent_1);
                continue;
            }
            if (!this.isSorted && !sorted && l > 1)
                sortArray(unit);
            var child = parent_1.getChild(SortedArray.ofSortedArray(unit));
            var pivot = symmGroups.add(child.id, child);
            if (child !== pivot)
                child = pivot.applyOperator(child.id, child.conformation.operator, true);
            newUnits[newUnits.length] = child;
        }
        return Structure.create(newUnits, { parent: this.parent });
    };
    StructureSubsetBuilder.prototype.getStructure = function () {
        return this._getStructure(false);
    };
    StructureSubsetBuilder.prototype.getStructureDeduplicate = function () {
        return this._getStructure(true);
    };
    StructureSubsetBuilder.prototype.setSingletonLocation = function (location) {
        var id = this.ids[0];
        location.unit = this.parent.unitMap.get(id);
        location.element = this.unitMap.get(id)[0];
    };
    Object.defineProperty(StructureSubsetBuilder.prototype, "isEmpty", {
        get: function () {
            return this.elementCount === 0;
        },
        enumerable: false,
        configurable: true
    });
    return StructureSubsetBuilder;
}());
export { StructureSubsetBuilder };
//# sourceMappingURL=subset-builder.js.map